import {
    GoogleAuthProvider,
    User,
    browserLocalPersistence,
    getAuth,
    signInWithEmailAndPassword,
    signInWithPopup,
} from "firebase/auth";

export async function signInWithPassword(user: string, password: string) {
    const auth = getAuth();
    await auth.setPersistence(browserLocalPersistence);

    let credentials;
    try {
        credentials = await signInWithEmailAndPassword(auth, user, password);
    } catch (e) {
        const anyErr = e as { code?: string; message?: string } | undefined;
        const code = anyErr?.code ?? "";
        if (code === "auth/too-many-requests") {
            throw new Error("Too many failed login attempts. Please try again later.");
        }
        if (code === "auth/user-not-found") {
            throw new Error("This email does not exist.");
        }
        if (code === "auth/wrong-password") {
            throw new Error("Wrong password.");
        }
        if (code === "auth/invalid-email") {
            throw new Error("Invalid email address.");
        }
        throw new Error(anyErr?.message || "Login failed");
    }

    if (credentials.user) {
        return credentials.user;
    }

    throw new Error("Login failed");
}

/**
 * Enables user to sign in with Google. Will check if the user is also avaiable
 * as a client user in the database. If not will be signed out automatically.
 */
export async function signInWithGoogle(): Promise<[string, User]> {
    await getAuth().setPersistence(browserLocalPersistence);

    const provider = new GoogleAuthProvider();
    provider.addScope("profile");
    provider.addScope("email");

    const result = await signInWithPopup(getAuth(), provider);
    const token = await result.user.getIdToken();

    return [token, result.user];
}

export async function signOut() {
    const auth = getAuth();
    await auth.signOut();
}
